import { identityActions } from '@figure/frontlib-onboarding-redux';
import useRedux from './useRedux';

/**
 * Gets identity reducer and actions.
 */
const useIdentity = () => {
  const identityActionsAndReducer = useRedux('identityReducer', identityActions);

  return {
    ...identityActionsAndReducer,
    isAuthenticated:
      typeof identityActionsAndReducer.jwt === 'string' && identityActionsAndReducer.jwt.length > 0,
  };
};

export default useIdentity;
